import { FormWrapper } from '@sleepstation/components-form'
import { defaultDarkerTheme } from '@sleepstation/themes-public-site'
import React, { useEffect } from 'react'
import { useMutation } from 'urql'
import { useNavigate } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import { isNotNil } from 'ramda'
import HubDbasQuestionnairePage from './HubDbasQuestionnairePage'
import { CreateQuestionnaireResponse } from '../../../graphql/documents'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const RESULTS_PATH = `/hub/what-do-you-know-about-sleep/results/`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const HubDbasQuestionnaireModule = () => {
  const navigate = useNavigate()
  const [questionnaireResult, createQuestionnaireResponse] = useMutation(
    CreateQuestionnaireResponse
  )

  useEffect(() => {
    if (isNotNil(questionnaireResult.data)) {
      navigate(RESULTS_PATH)
    }
  }, [questionnaireResult.data, navigate])

  return (
    <ThemeProvider theme={defaultDarkerTheme}>
      <FormWrapper
        wrappedComponent={HubDbasQuestionnairePage}
        onSuccess={createQuestionnaireResponse}
      />
    </ThemeProvider>
  )
}

export default HubDbasQuestionnaireModule
